/**
 * @generated SignedSource<<949d2aaa284cf03259e0d0b95101a5b4>>
 * @relayHash 2cae7491af53456249f8f30c1d13de78
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d17c91eb6f04d9bc3c1dc61ca25e1badc12e44fdd3e75e8ed9f67cfffbb959ff

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_DesignPanelOldQuery } from './ui_DesignPanelOldQuery.graphql';

const node: PreloadableConcreteRequest<ui_DesignPanelOldQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d17c91eb6f04d9bc3c1dc61ca25e1badc12e44fdd3e75e8ed9f67cfffbb959ff",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "devOps",
            "ariGraph",
            "relationships"
          ]
        }
      ]
    },
    "name": "ui_DesignPanelOldQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
